import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { AG_GRID_DEFAULT_OPTIONS, onlyLinkFollowingByIdButton } from '../../../../core/config/aggrid.default.config';
import { AppRoutes } from '../../../../shared/route-paths.const';
import { SepaDtoOut } from '../../../models/sepa.model';
import { ContabilidadSepaService } from '../../../services/contabilidad-sepa.service';

@Component({
  selector: 'app-sepa-list',
  standalone: true,
  imports: [CommonModule, RouterModule, AgGridAngular, MatIconModule],
  templateUrl: './sepa-list.component.html',
  styleUrl: './sepa-list.component.scss',
})
export class SepaListComponent implements OnInit {
  sepas: SepaDtoOut[] = [];
  gridApi!: GridApi;

  constructor(
    private readonly service: ContabilidadSepaService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.obtenerSepas();
  }

  gridOptions: GridOptions = {
    ...AG_GRID_DEFAULT_OPTIONS,
    onGridReady: (params) => (this.gridApi = params.api),
  };

  columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'fechaGeneracionSepa', headerName: 'Fecha Generación SEPA', type: 'dateColumn' },
    { field: 'proveedorNombre', headerName: 'Proveedor' },
    { field: 'cuentaBancariaIban', headerName: 'Cuenta Bancaria' },
    { field: 'observaciones', headerName: 'Observaciones' },
    { field: 'validado', headerName: 'Remesa Validada', type: 'booleanColumn' },
    { field: 'validadoContabilidad', headerName: 'Contabilidad Validada', type: 'booleanColumn' },
    { field: 'hasVenta', headerName: 'Tiene Venta', type: 'booleanColumn' },
    onlyLinkFollowingByIdButton(AppRoutes.CONTABILIDAD_ONDA.SEPA),
  ];

  obtenerSepas(): void {
    this.service.getSepas().subscribe({
      next: (data) => {
        this.sepas = data;
      },
      error: (err) => {
        console.error('SepaListComponent - Error:', err);
      },
    });
  }

  onRowDoubleClicked(event: any): void {
    this.router.navigate([`${AppRoutes.CONTABILIDAD_ONDA.SEPA}/${event.data.id}`]);
  }

  createSepa(): void {
    this.router.navigate([AppRoutes.CONTABILIDAD_ONDA.SEPA_NEW]);
  }

  goToSepasNoProcesables(): void {
    window.open(`${AppRoutes.CONTABILIDAD_ONDA.SEPA}/facturas-no-procesables`, '_blank');
  }
}
